import React from "react";
import { useState } from "react";
import Form from 'react-bootstrap/Form'
import Button from "react-bootstrap/Button";

const Relacion = ({arrPersonas, handleGuardarRelacionPersonaProyecto}) => {
    const [usuario, setUsuario] = useState(0);
    const [usuarioNombre, setUsuarioNombre] = useState("");
    const [supervisor, setSupervisor] = useState(0);
    const [supervisorNombre, setSupervisorNombre] = useState("");

    return(
        <Form>
            <Form.Group controlId="formColaborador" style={{paddingTop: '1em'}}>
                <Form.Label>Colaborador</Form.Label>
                <Form.Select 
                    key={"selectUsuarioPersonaRelacion"} 
                    value={usuario}
                    onChange={(event)=>{ 
                        setUsuario(event.target.value) 
                        setUsuarioNombre(event.target.selectedOptions[0].text)
                    }}
                >
                    <option key="opt_colaborador0" value={0}>--- Escoge un colaborador ---</option>
                    {
                        (Array.isArray(arrPersonas)) ?
                            arrPersonas.map(usuario =>
                                <option 
                                    key={'opt_colab'+usuario.IDUSUARIO}
                                    value={usuario.IDUSUARIO} 
                                >
                                    {usuario.NOMBREUSUARIO} ( {usuario.PUESTO} )
                                </option>
                            )
                        : <option key="opt_colaborador1" value={1}>No es array</option>
                    }
                </Form.Select>
            </Form.Group>
            <Form.Group controlId="formSupervisorColaborador" style={{paddingTop: '1em'}}>
                <Form.Label>Supervisor del colaborador</Form.Label>
                <Form.Select 
                    key={"selectSupervisorPersonaRelacion"}
                    value={supervisor}
                    onChange={(event)=>{ 
                        setSupervisor(event.target.value)
                        setSupervisorNombre(event.target.selectedOptions[0].text)
                    }}
                >
                    <option key="opt_supervisor0" value={0}>--- Escoge el supervisor ---</option>
                    {
                        (Array.isArray(arrPersonas)) ?
                            arrPersonas.map(usuario =>
                                <option 
                                    key={'opt_supervisor'+usuario.IDUSUARIO} 
                                    value={usuario.IDUSUARIO}
                                >
                                    {usuario.NOMBREUSUARIO} ( {usuario.PUESTO} )
                                </option>
                            )
                        : <option key="opt_supervisor1" value={1}>No es array</option>
                    }
                </Form.Select>
            </Form.Group>
            <br/>
            <Button variant="primary" onClick={()=>{
                handleGuardarRelacionPersonaProyecto(usuario, usuarioNombre, supervisor, supervisorNombre)}}>
                Agregar colaborador
            </Button>
        </Form>
    )
}

export default Relacion;